import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/seats.svg
 */
const IconSeats: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M19.297 17H20a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v9a2 2 0 002 2h6.285l1.143-1H4a1 1 0 01-1-1V6a1 1 0 011-1h16a1 1 0 011 1v9a1 1 0 01-1 1h-2.041l1.338 1z"
      fill="currentColor"
    />
    <path d="M4 5.625h3v1H4v-1zM8 5.625h1v1H8v-1z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.75 13a3 3 0 100-6 3 3 0 000 6zm0 1a4 4 0 100-8 4 4 0 000 8zM19.875 19a4.229 4.229 0 00-.26-.735 4.625 4.625 0 00-1.114-1.5 5.338 5.338 0 00-1.709-1.025 5.859 5.859 0 00-2.042-.365c-.703 0-1.398.125-2.043.365-.644.24-1.224.59-1.708 1.026-.483.435-.86.946-1.115 1.5-.11.239-.197.484-.26.734h10.251zm1.025 0a5.204 5.204 0 00-.376-1.153 5.624 5.624 0 00-1.355-1.825 6.336 6.336 0 00-2.027-1.219 6.857 6.857 0 00-2.392-.428c-.82 0-1.633.146-2.392.428a6.336 6.336 0 00-2.027 1.22 5.626 5.626 0 00-1.355 1.824A5.208 5.208 0 008.6 19c-.067.33-.1.664-.1 1H21c0-.336-.034-.67-.1-1z"
      fill="currentColor"
    />
  </svg>
);

export default IconSeats;
